import { render, staticRenderFns } from "./BuildingDrawingsTab.vue?vue&type=template&id=bf839bf8"
import script from "./BuildingDrawingsTab.vue?vue&type=script&lang=ts"
export * from "./BuildingDrawingsTab.vue?vue&type=script&lang=ts"
import style0 from "./BuildingDrawingsTab.vue?vue&type=style&index=0&id=bf839bf8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports